import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'mobile-referral-component',
    templateUrl: './mobile-referral.component.html',
    styleUrls: ['./mobile-referral.component.scss'],
})
export class MobileReferralPage implements OnInit {
    appStore: string;
    playStore: string;
    isNMConnect: boolean = false;
    referralUrl: string;
    appName: string;
    logoSrc: string;
    downloadTitle: string;
    downloadDescription: string;

    constructor(private activatedRoute: ActivatedRoute) {}

    ngOnInit() {
        // Get all query parameters
        this.activatedRoute.queryParams.subscribe(params => {
            const accesscode = params['accesscode'];

            // Check if this is NMConnect specific
            this.isNMConnect = accesscode === 'nmreferral';

            if (this.isNMConnect) {
                // NMConnect specific configuration
                this.appStore =
                    'https://apps.apple.com/us/app/nmconnect/id1505881354';
                this.playStore =
                    'https://play.google.com/store/apps/details?id=com.nmcrisisline.app';
                this.appName = 'NMConnect';
                this.logoSrc = './assets/img/nm-connect-logo-v4-small.png';
                this.downloadTitle = 'Download NMConnect!';
                this.downloadDescription =
                    'Thanks for your interest in downloading NMConnect! To use the link we sent you, you must first download the NMConnect app from your phone by using the Apple App Store or Google Play Store.';
                this.referralUrl =
                    'https://app.welltrack-boost.com/referral?accesscode=nmreferral';
            } else {
                // General Welltrack Boost configuration
                this.appStore =
                    'https://apps.apple.com/us/app/welltrack-boost/id1039262985';
                this.playStore =
                    'https://play.google.com/store/apps/details?id=com.cyberpsyc.welltrackapp';
                this.appName = 'Welltrack Boost';
                this.logoSrc =
                    './assets/img/welltrack-logos/well-track-white-logo.svg';
                this.downloadTitle = 'Download Welltrack Boost!';
                this.downloadDescription =
                    'Thanks for your interest in downloading Welltrack Boost! To use the link we sent you, you must first download the Welltrack Boost app from your phone by using the Apple App Store or Google Play Store.';

                // Build referral URL with all query parameters
                this.buildReferralUrl(params);
            }
        });
    }

    private buildReferralUrl(params: any) {
        const baseUrl = 'https://app.welltrack-boost.com/referral';
        const queryString = new URLSearchParams();

        // Add all query parameters to the referral URL
        Object.keys(params).forEach(key => {
            if (params[key]) {
                queryString.append(key, params[key]);
            }
        });

        this.referralUrl = queryString.toString()
            ? `${baseUrl}?${queryString.toString()}`
            : baseUrl;
    }
}
